import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';

interface UsersListModalData {
  title: string;
  users: any[];
  groups?: any[];
  positionByUserId?: Record<string, number>;
}

@Component({
  selector: 'app-users-list-modal',
  templateUrl: './users-list-modal.component.html',
  styleUrls: ['./users-list-modal.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UsersListModalComponent {
  title: string;
  users: any[];
  groups: any[];
  positionByUserId: Record<string, number>;
  groupSelected = 'general';

  private allUsers: any[];

  constructor(
    public sheetRef: MatBottomSheetRef<UsersListModalComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: UsersListModalData,
  ) {
    this.title = data.title || 'Participantes';
    this.allUsers = data.users || [];
    this.users = this.allUsers;
    this.groups = data.groups || [];
    this.positionByUserId = data.positionByUserId || {};
  }

  selectGroup(groupId: string): void {
    this.groupSelected = groupId;
    this.users =
      groupId === 'general'
        ? this.allUsers
        : this.allUsers.filter((user) => user.groups?.includes(groupId));
  }

  close(): void {
    this.sheetRef.dismiss();
  }

  selectUser(user: any): void {
    this.sheetRef.dismiss(user);
  }
}
